<template>
  <div>
    <h1>Logs</h1>

    <div class="mt-3">
      <!-- Game filter -->
      <LogsAggs
        class="d-inline me-2"
        field="game"
        :selectaggs="filter.game"
        @selected="setFilter('game', $event)"
      />

      <!-- Level filter -->
      <LogsAggs
        class="d-inline me-2"
        field="level"
        :selectaggs="filter.level"
        @selected="setFilter('level', $event)"
      />
    </div>

    <!-- Filter input and Search button -->
    <div class="input-group mb-1 mt-3">
      <!-- Filter input -->
      <textarea
        type="text"
        class="form-control"
        placeholder="text of filter"
        v-model="filter.filter"
        rows="1"
        ref="textarea"
        @focus="resize"
        @keyup="resize"
      ></textarea>
      <!-- Add to dynamically refresh list when typing filter -->
      <!-- v-on:input="sendToParent()" -->

      <!-- OR or END button -->
      <button
        type="button"
        class="btn bg-transparent operation"
        :class="checkFilter()"
        :operation="filter.operation"
        @click="
          filter.operation == 'or'
            ? (filter.operation = 'and')
            : (filter.operation = 'or');
          getNextPage(true);
        "
      >
        {{ filter.operation.toUpperCase() }}
      </button>

      <!-- Clear filter button -->
      <button
        type="button"
        class="btn bg-transparent clear"
        @click="
          filter.filter = '';
          getNextPage(true);
        "
      >
        <span><i class="fa fa-times"></i>x</span>
      </button>

      <!-- Search button -->
      <button class="btn btn-secondary" @click="getNextPage(true)">
        <i class="bi bi-search"></i>
      </button>
    </div>

    <div class="d-flex">
      <!-- Filter example (help) -->
      <div class="form-text flex-grow-1 help">
        <div class="d-inline-flex gap-1">
          <button
            class="btn btn-sm btn-outline-secondary dropdown-toggle border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseHelp"
            aria-expanded="false"
            aria-controls="collapseHelp"
          >
            Help
          </button>
        </div>
      </div>

      <!-- Current timestamp filter type -->
      <div class="form-text time-label">
        <!-- Calendar dropdown button -->
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary dropdown-toggle border-0 float-end"
          id="dropdownMenuButtonCalendar"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <span><i class="bi bi-calendar"></i></span>
          &nbsp;Date {{ timestampFilterMap[filter.timestamp.name].label }}
          <span v-if="filter.refresh.refresh">
            ({{ filter.refresh.value }} sec)
          </span>
        </button>

        <!-- Callendar dropdown menu -->
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButtonCalendar">
          <!-- Timestamps -->
          <li v-for="(time, index) in timestampFilterMap" :key="index">
            <div class="dropdown-item" @click="setTimestamp(index)">
              {{ time.label }}
            </div>
            <div v-if="index == 'all'" class="dropdown-divider"></div>
          </li>

          <!-- Refresh -->
          <li>
            <div class="dropdown-divider"></div>

            <div class="dropdown-item d-flex">
              <!-- Refresh checkbox -->
              <div class="form-check mt-2 me-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexCheckRefresh"
                  v-model="filter.refresh.refresh"
                  @change="saveFilter()"
                />
                <label class="form-check-label" for="flexCheckRefresh"
                  >Refresh every</label
                >
              </div>

              <!-- Refresh timeout -->
              <div class="">
                <input
                  type="number"
                  class="form-control"
                  placeholder="sec"
                  min="1"
                  max="120"
                  style="width: 73px"
                  v-model="filter.refresh.value"
                />
              </div>

              <!-- Refresh applay button -->
              <button
                class="btn btn-outline-secondary ms-1"
                @click="saveFilter()"
              >
                ok
              </button>
            </div>
          </li>
        </ul>
      </div>

      <!-- Eye icon in refresh mode -->
      <button
        v-if="filter.refresh.refresh"
        type="button"
        class="btn btn-sm btn-outline-secondary border-0 float-end"
        style="margin-top: -3px"
        @click="filter.refresh.eye = !filter.refresh.eye"
      >
        <i v-if="filter.refresh.eye" class="bi bi-eye"></i>
        <i v-else class="bi bi-eye-slash"></i>
      </button>
    </div>

    <!-- Help content -->
    <div class="collapse mt-3" id="collapseHelp">
      <div class="card card-body">
        Example: "verbosity": "Log", "mapid": "test1234567890", "message":
        "maintenance"
      </div>
    </div>

    <div v-if="!(filter.refresh.refresh && !filter.refresh.eye)">
      <!-- Source filter -->
      <div
        class="btn-group btn-group-sm view-filter"
        role="group"
        aria-label="View Server, Client or All logs"
      >
        <span class="d-none d-md-block">Source: </span>
        <input
          type="radio"
          class="btn-check"
          name="btnradio-source"
          id="btnradio5"
          autocomplete="off"
          value="server"
          v-model="filter.source"
          @change="changeOrder"
        />
        <label class="btn btn-outline-secondary" for="btnradio5">server</label>

        <input
          type="radio"
          class="btn-check"
          name="btnradio-source"
          id="btnradio6"
          autocomplete="off"
          value="client"
          v-model="filter.source"
          @change="changeOrder"
        />
        <label class="btn btn-outline-secondary" for="btnradio6">client</label>

        <input
          type="radio"
          class="btn-check"
          name="btnradio-source"
          id="btnradio7"
          autocomplete="off"
          value="all"
          v-model="filter.source"
          @change="changeOrder"
        />
        <label class="btn btn-outline-secondary" for="btnradio7">all</label>
      </div>

      <!-- Mapid filter -->
      <div class="mapid-filter mt-2">
        <LogsAggs
          class="verbosity"
          field="mapid"
          fieldLabel="Map ID"
          all="All"
          :noborder="true"
          :selectaggs="filter.mapid"
          :filter="filterMapid"
          :refresh="filterMapidRefresh"
          @selected="setFilter('mapid', $event)"
        />
      </div>

      <!-- Userid filter -->
      <div v-if="filter.source != 'server'" class="userid-filter">
        <LogsAggs
          class="verbosity"
          field="userid"
          fieldLabel="User ID"
          all="All"
          :noborder="true"
          :selectaggs="filter.userid"
          :filter="filterUserid"
          :refresh="filterUseridRefresh"
          @selected="setFilter('userid', $event)"
        />
      </div>

      <!-- Verbosity filter -->
      <div class="d-flex verbosity-filter">
        <div class="p-1 verbosity-label">Log verbosity:</div>
        <LogsAggs
          class="verbosity"
          field="verbosity"
          all="All"
          :noborder="true"
          :selectaggs="filter.verbosity"
          @selected="setFilter('verbosity', $event)"
        />
      </div>

      <!-- Total search results -->
      <div v-if="total" class="ms-1 total">Found total: {{ total }}</div>

      <!-- View and Sort -->
      <div>
        <!-- Complex or simple view -->
        <div
          class="btn-group btn-group-sm view-filter"
          role="group"
          aria-label="Complex or simple view toggle"
        >
          <span class="d-none d-md-block">View: </span>
          <input
            type="radio"
            class="btn-check"
            name="btnradio-view"
            id="btnradio1"
            autocomplete="off"
            value="complex"
            v-model="filter.view"
            @change="saveFilter"
          />
          <label class="btn btn-outline-secondary" for="btnradio1"
            >complex</label
          >

          <input
            type="radio"
            class="btn-check"
            name="btnradio-view"
            id="btnradio2"
            autocomplete="off"
            value="simple"
            v-model="filter.view"
            @change="saveFilter"
          />
          <label class="btn btn-outline-secondary" for="btnradio2"
            >simple</label
          >
        </div>

        <!-- Sort ascending or descending -->
        <div
          class="btn-group btn-group-sm view-filter float-end"
          role="group"
          aria-label="Sort ascending or descending toggle"
        >
          <span class="d-none d-md-block">Sort: </span>
          <input
            type="radio"
            class="btn-check"
            name="btnradio-sort"
            id="btnradio3"
            autocomplete="off"
            value="ascending"
            v-model="filter.sort"
            @change="changeOrder"
          />
          <label class="btn btn-outline-secondary" for="btnradio3"
            >ascending</label
          >

          <input
            type="radio"
            class="btn-check"
            name="btnradio-sort"
            id="btnradio4"
            autocomplete="off"
            value="descending"
            v-model="filter.sort"
            @change="changeOrder"
          />
          <label class="btn btn-outline-secondary" for="btnradio4"
            >descending</label
          >
        </div>
      </div>

      <!-- Download log button -->
      <a
        v-if="hits.length"
        class="btn btn-sm download float-end mt-3"
        :href="
          serverUrl +
          '/api/v1/log/' +
          makeListFilterCompress() +
          '/DadminLog.txt'
        "
        download="DadminLog.txt"
        target="_blank"
        rel="noopener noreferrer"
        >Download Log</a
      >
    </div>

    <!-- Logs list -->
    <div v-if="!error" class="list mt-4">
      <div
        v-for="(row, index) in hits"
        :key="index"
        class="list-item"
        :class="filter.view"
      >
        <!-- Horizontal separator or empty div depending on index -->
        <div v-if="filter.view == 'complex'">
          <!-- <hr v-if="index" /> -->
          <hr />
        </div>

        <!-- Complex view -->
        <div v-if="filter.view == 'complex'">
          <!-- Timestamp -->
          <div class="timestamp">
            {{ index + 1 }}.
            {{ row._source["@timestamp"].replace("T", " ").replace("Z", "") }}
          </div>

          <!-- Mapid -->
          <div v-if="row._source.mapid" class="timestamp text-muted">
            "mapid": "{{ row._source.mapid }}"
          </div>

          <!-- Userid -->
          <div v-if="row._source.userid" class="timestamp text-muted">
            "userid": "{{ row._source.userid }}"
          </div>

          <!-- Source -->
          <div v-if="row._source.source" class="timestamp text-muted">
            "source": "{{ row._source.source }}"
          </div>

          <!-- Game -->
          <div class="timestamp text-muted">
            "game": "{{ row._source.game }}"
          </div>

          <!-- Level -->
          <div v-if="row._source.level" class="timestamp text-muted">
            "level": "{{ row._source.level }}"
          </div>

          <!-- Region -->
          <div v-if="row._source.region" class="timestamp text-muted">
            "region": "{{ row._source.region }}"
          </div>

          <!-- Verbosity -->
          <div class="timestamp" :class="getColor(row._source.verbosity)">
            "verbosity": "{{ row._source.verbosity }}"
          </div>

          <div class="mb-2"></div>
        </div>

        <!-- Message -->
        <div class="message">
          <span v-if="filter.view == 'simple'" class="text-muted">
            [{{ row._source["@timestamp"].replace("T", " ").replace("Z", "") }}]
            <span v-if="filter.source == 'all' && row._source.source">
              [{{ row._source.source }}]</span
            >
            {{ row._source.verbosity }}:
          </span>
          {{ row._source.message }}
        </div>
      </div>
    </div>

    <!-- Error message -->
    <div v-else class="alert alert-danger mt-3" role="alert">{{ error }}</div>

    <!-- Next page button -->
    <div v-if="previous && !error" class="text-center next-page">
      <hr />
      <a
        class="btn btn-secondary"
        :class="processGetPage ? 'disabled d-none' : ''"
        @click="getNextPage()"
      >
        <i v-if="!processGetPage" class="bi bi-box-arrow-down"></i>
        <i v-else class="bi bi-arrow-clockwise"></i>
      </a>
    </div>

    <!-- Loading indicator -->
    <div
      v-if="processGetPage && showLoader"
      class="d-flex justify-content-center m-4"
    >
      <div class="spinner-border text-secondary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Go to top button -->
    <GoTop />
  </div>
</template>

<script>
import LogsAggs from "../LogsAggs.vue";
import GoTop from "../GoTop.vue";

const cmdLogsList = "logs.list/";

export default {
  name: "PageLogs",

  components: {
    LogsAggs: LogsAggs,
    GoTop,
  },

  data() {
    return {
      hits: [],

      previous: "",
      error: "",
      total: 0,

      serverUrl: "",

      filter: {
        filter: "",
        game: "",
        level: "",
        mapid: "",
        userid: "",
        verbosity: "",
        view: "complex",
        sort: "descending",
        operation: "AND",
        source: "all",
        timestamp: {
          name: "all",
          value: "",
        },
        refresh: {
          refresh: false,
          value: 0,
          eye: true,
        },
      },

      filterMapidRefresh: false,
      filterMapid: "",

      filterUseridRefresh: false,
      filterUserid: "",

      timestampFilterMap: {
        all: { label: "All" },
        today: { label: "Today" },
        yesterday: { label: "Yesterday and Today" },
        week: { label: "This week" },
        month: { label: "This month" },
        year: { label: "This year" },
      },

      // Auto refresh logs
      refresh: false,
      refreshTimeout: 6,

      processGetPage: true,
      showLoader: false,

      closed: false,
    };
  },

  mounted() {
    const that = this;

    // Get filter value from local storage
    const filter = localStorage.getItem("logsFilter") || "";
    try {
      this.filter = JSON.parse(filter);
    } catch (e) {
      this.filter = { filter: {} };
    }
    // Set filters default values
    if (!this.filter.view) this.filter.view = "complex";
    if (!this.filter.sort) this.filter.sort = "descending";
    if (!this.filter.operation) this.filter.operation = "and";
    if (!this.filter.timestamp) this.filter.timestamp = { name: "all" };
    if (!this.filter.source) this.filter.source = "all";
    if (!this.filter.refresh)
      this.filter.refresh = { refresh: false, value: 6, eye: true };

    // Get http server url to download logs
    this.getServerUrl();

    // Resize textarea
    this.resize();

    // Add 'reader' which will receive data from WebRTC Data Channel
    this.reader = this.teoweb.addReader(function (gw, data) {
      // Process error
      if (gw.err) {
        console.error(gw.err);
        that.error = "Error: " + gw.err;
        return;
      }
      that.error = "";

      // Process answer to cmdUsersList command
      if (gw.command.startsWith(cmdLogsList)) {
        that.processGetPage = false;
        that.showLoader = false;

        that.webasmReady.then(() => {
          // Parse answer
          try {
            const answer = JSON.parse(window.decompressData(data));
            that.previous = answer.previous;
            if (answer.hits) {
              // Check refresh flag and replace or add logs
              if (that.filter.refresh.refresh && window.scrollY == 0)
                that.hits = answer.hits;
              else that.hits = that.hits.concat(answer.hits);

              // Update total found
              that.total = answer.total;
            }
          } catch (e) {
            console.error("incorrect users list data:", data);
          }
        });
      }
    });

    // Send get list request
    this.whenLogin.then(() => this.getNextPage(true));

    // Check list scroll to bottom
    window.addEventListener("scroll", this.scrollListener);

    // Auto refresh logs executed flag
    let refreshExecuted = false;

    /**
     * Refresh - Schedules and executes refreshes of the logs list every filter.refresh.value seconds.
     * If the user has scrolled from the top of the list or has changed the sort order to ascending,
     * the refresh is skipped.
     *
     * @param {boolean} [firstCall=false] - If true, the refresh is not skipped, even if the user has
     * scrolled from the top of the list.
     */
    const refresh = () => {
      if (that.filter.refresh.refresh && !refreshExecuted) {
        refreshExecuted = true;
        // Set timeout filter.refresh.value sec to get next page
        setTimeout(() => {
          refreshExecuted = false;

          // Skip if refresh mode is off or user has scrolled from top or sort
          // is ascending
          if (
            !that.filter.refresh.refresh ||
            window.scrollY != 0 ||
            that.filter.sort == "ascending"
          ) {
            return;
          }

          // Get next page in refresh mode (get new logs)
          that.getNextPage(true);
        }, that.filter.refresh.value * 1000);
      }

      // Check if this component is closed
      if (that.closed) return;

      // Schedule next check
      requestAnimationFrame(refresh);
    };

    // Schedule first refresh check
    refresh();
  },

  unmounted: function () {
    this.closed = true;
    this.teoweb.delReader(this.reader);
    window.removeEventListener("scroll", this.scrollListener);
  },

  methods: {
    /**
     * Get the URL of the http server.
     * The URL is used to construct the URLs of the logs files.
     */
    getServerUrl() {
      const cmdImageUrl = "images.url";

      this.sendCmd(cmdImageUrl).then(
        // Process success answer
        (data) => {
          // Set the server URL
          this.serverUrl = data;
          console.debug("server url:", data);
          return;
        },
        // Process an error
        (err) => console.error("getServerUrl error:", err)
      );
    },

    /**
     * scrollListener - Checks whether the user has scrolled to the bottom of the list.
     * If so, it calls getNextPage to get the next page of players.
     *
     * This function is called every time the user scrolls.
     */
    scrollListener() {
      // Skip if the mapid or userid dropdown menu is open
      const elements = [
        document.getElementById("dropdownMenuButton-mapid"),
        document.getElementById("dropdownMenuButton-userid"),
      ];
      for (const element of elements) {
        if (element && element.className.includes("show")) {
          return;
        }
      }

      // Check if the user has scrolled to the bottom and get next page
      if (this.previous && !this.error && !this.processGetPage) {
        const scrollTop = window.scrollY;
        const scrollHeight = document.body.scrollHeight;
        const clientHeight = window.innerHeight;
        if (scrollTop + clientHeight + 10000 >= scrollHeight) {
          this.getNextPage();
        }
      }
    },

    /**
     * setTimestamp - Sets the timestamp filter to the selected value.
     * This function is called when the user selects a timestamp filter.
     *
     * @param {string} timestamp - Name of the timestamp filter.
     * @function setTimestamp
     */
    setTimestamp(timestamp) {
      let timestampValue = "";
      switch (timestamp) {
        /**
         * Today filter
         */
        case "today":
          // @timestamp > "2025-04-07"
          timestampValue = new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
            .toISOString()
            .split("T")[0];
          break;

        /**
         * Yesterday filter
         */
        case "yesterday":
          // @timestamp > "2025-04-07"
          timestampValue = new Date(
            new Date().getTime() - 2 * 24 * 60 * 60 * 1000
          )
            .toISOString()
            .split("T")[0];
          break;

        /**
         * This week filter
         */
        case "week": {
          // @timestamp > "2025-04-07"
          const today = new Date();
          const lastSunday = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate() - today.getDay() + 1
          );
          timestampValue = lastSunday.toISOString().split("T")[0];
          break;
        }

        /**
         * This month filter
         */
        case "month": {
          // @timestamp > "2025-04-07"
          const lastDayOfLastMonth = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
          );
          timestampValue = lastDayOfLastMonth.toISOString().split("T")[0];
          break;
        }

        /**
         * This year filter
         */
        case "year": {
          // @timestamp > "2025-04-07"
          const lastDayOfLastYear = new Date(
            new Date().getFullYear(),
            0,
            1
          ).toISOString();
          timestampValue = lastDayOfLastYear.split("T")[0];
          break;
        }
      }
      this.filter.timestamp = { name: timestamp, value: timestampValue };
      this.getNextPage(true);
    },

    /**
     * Save filter to local storage for future use
     *
     * @function saveFilter
     */
    saveFilter() {
      // Convert filter object to string
      const filter = JSON.stringify(this.filter);

      // Save filter string to local storage
      localStorage.setItem("logsFilter", filter);
    },

    /**
     * changeOrder - Called when the user selects a different sort order.
     * It calls getNextPage to get the list of logs with the new sort order.
     *
     * @function changeOrder
     */
    changeOrder() {
      // Call getNextPage to get the list of logs with the new sort order
      this.getNextPage(true);
    },

    /**
     * getNextPage - Sends a command to the WebRTC server to get the next
     * page of logs.
     * @param {string} filter - Filter string to filter logs.
     * @param {boolean} refresh - If true, it will remove all logs and start from the first page.
     */
    getNextPage(refresh = false, refresFilter = true) {
      if (refresh) {
        // Remove all logs and set previous to empty string
        this.previous = "";

        // Clear hits if not refresh mode
        if (!this.filter.refresh.refresh) this.hits = [];

        // Make mapid filter
        if (refresFilter !== 'mapid' && refresFilter !== 'userid') {
          this.makeMapidFilter((newFilter) => {
            // Refresh mapid filter if it has not changed
            if (newFilter == this.filterMapid) this.refreshMapidFilter();
            // Set mapid filter if it has changed
            else {
              this.filterMapid = newFilter;
            }
          });
        }

        // Make userid filter
        if (refresFilter !== 'userid') {
          this.makeUseridFilter((newFilter) => {
            // Refresh userid filter if it has not changed
            if (newFilter == this.filterUserid) this.refreshUseridFilter();
            // Set userid filter if it has changed
            else {
              this.filterUserid = newFilter;
            }
          });
        }

        // Save filter to local storage for future use
        this.saveFilter();
      }

      // Set flag to prevent multiple requests
      this.processGetPage = true;

      // Show loader after 250ms
      setTimeout(() => {
        if (this.processGetPage) this.showLoader = true;
      }, 250);

      // Make filter
      const filter = this.makeListFilter();

      // Order
      const order = this.filter.sort == "descending" ? "desc" : "asc";

      // Send command to the teoweb server
      this.teoweb.sendCmd(cmdLogsList + this.previous + "/" + order, filter);
    },

    /**
     * makeSerschFilter - Makes a filter string based on the search string.
     * @return {string} - Filter string.
     */
    makeSerschFilter() {
      let filter = this.filter.filter || "";
      filter = filter.trim(filter);

      // Skip if filter string is empty
      if (filter.length == 0) return filter;

      // If filter string does not begins with "
      if (filter[0] != '"') {
        // Split filter to words and remove empty words
        const words = filter
          .split(/[ ,.!?:;"'`~@#$%^&*()[\]+\-=<>\\//\n]/)
          .filter((word) => word != "");

        if (this.filter.operation == "or") {
          // Make filter for OR operation

          // Concatenate words with space
          filter = words.join(" ");

          // Make filter for OR operation
          filter = '"message":"' + filter + '"';
        } else {
          // Make filter for AND operation

          // Range by words
          filter = "";
          for (let i = 0; i < words.length; i++) {
            if (filter) filter += ",";
            // Make filter for each word
            filter += '"message":"' + words[i] + '"';
          }
        }
      }

      return filter;
    },

    /**
     * makeListFilter - Makes a filter string based on the filters.
     * @return {string} - Filter string.
     */
    makeListFilter() {
      // Make filter string
      let filter = "";

      // Timestamp component
      // If timestamp filter is set, add it to the filter string
      // Example: "@timestamp": "2024-10-01"
      if (this.filter.timestamp && this.filter.timestamp.value) {
        if (filter) filter += ",";
        filter += '"@timestamp":"' + this.filter.timestamp.value + '"';
      }

      // Source component
      // If source filter is set to "server" or "client", add it to the filter
      // string
      // Example: "source.keyword": "server"
      if (this.filter.source && this.filter.source != "all") {
        if (filter) filter += ",";
        filter += '"source.keyword":"' + this.filter.source + '"';
      }

      // Game component
      // If game filter is set, add it to the filter string
      // Example: "game.keyword": "Dustland"
      if (this.filter.game) {
        if (filter) filter += ",";
        filter += '"game.keyword":"' + this.filter.game + '"';
      }

      // Level component
      // If level filter is set, add it to the filter string
      // Example: "level.keyword": "test1234567890"
      if (this.filter.level) {
        if (filter) filter += ",";
        filter += '"level.keyword":"' + this.filter.level + '"';
      }

      // Mapid component
      // If mapid filter is set, add it to the filter string
      // Example: "mapid.keyword": "test1234567890"
      if (this.filter.mapid) {
        if (filter) filter += ",";
        filter += '"mapid.keyword":"' + this.filter.mapid + '"';
      }

      // Userid component
      // If userid filter is set, add it to the filter string
      // Example: "userid.keyword": "test1234567890"
      if (this.filter.userid && this.filter.source != "server") {
        if (filter) filter += ",";
        filter += '"userid.keyword":"' + this.filter.userid + '"';
      }

      // Verbosity component
      // If verbosity filter is set, add it to the filter string
      // Example: "verbosity.keyword": "Log"
      if (this.filter.verbosity) {
        if (filter) filter += ",";
        filter += '"verbosity.keyword":"' + this.filter.verbosity + '"';
      }

      // Filter string
      // If filter string is set, add it to the filter string
      // Example: "message": "maintenance"
      if (this.filter.filter) {
        if (filter) filter += ",";
        filter += this.makeSerschFilter();
      }

      return filter;
    },

    /**
     * Compresses the list filter string.
     * Replaces "/" with "_" to make it a valid URL parameter.
     * @return {string} - Compressed filter string.
     */
    makeListFilterCompress() {
      return window.compressData(this.makeListFilter()).replace(/\//g, "_");
    },

    /**
     * Makes a filter string based on the game and level filters.
     * @return {string} - Filter string.
     */
    makeMapidFilter(f) {
      let filter = "";

      // Game component
      if (this.filter.game) {
        filter += '"game.keyword":"' + this.filter.game + '"';
      }

      // Level component
      if (this.filter.level) {
        if (filter) filter += ",";
        filter += '"level.keyword":"' + this.filter.level + '"';
      }

      // Timestamp component
      if (this.filter.timestamp && this.filter.timestamp.value) {
        if (filter) filter += ",";
        filter += '"@timestamp":"' + this.filter.timestamp.value + '"';
      }

      // Source component
      if (this.filter.source && this.filter.source != "all") {
        if (filter) filter += ",";
        filter += '"source.keyword":"' + this.filter.source + '"';
      }

      // String filter
      if (this.filter.filter) {
        if (filter) filter += ",";
        filter += this.makeSerschFilter();
      }

      // Call function
      if (f) f(filter);

      return filter;
    },

    /**
     * Makes a filter string based on the game and level filters.
     * @return {string} - Filter string.
     */
    makeUseridFilter(f) {
      let filter = this.makeMapidFilter();

      // Mapid component
      if (this.filter.mapid) {
        if (filter) filter += ",";
        filter += '"mapid.keyword":"' + this.filter.mapid + '"';
      }

      // Call function
      if (f) f(filter);

      return filter;
    },

    /**
     * Check if the filter is set and is a string that begins with '"'.
     * Used to hide the OR button if the filter is set and is a string.
     * @return {string} - "hide" if the filter should be hidden, "" otherwise.
     */
    checkFilter() {
      if (
        // Check if the filter is set
        this.filter.filter &&
        // Check if the filter is a string
        typeof this.filter.filter == "string" &&
        // Check if the filter string begins with '"'
        this.filter.filter.length > 0 &&
        this.filter.filter[0] == '"'
      )
        return "hide";
      else return "";
    },

    /**
     * Refreshes the mapid filter.
     * This function is called when the mapid filter changes and it needs to be refreshed.
     * It sets a flag to true and then sets it to false after 100ms.
     */
    refreshMapidFilter() {
      // Set flag to true
      this.filterMapidRefresh = true;

      // Set flag to false at the next tick
      setTimeout(() => (this.filterMapidRefresh = false));
    },

    /**
     * Refreshes the userid filter.
     * This function is called when the userid filter changes and it needs to be refreshed.
     * It sets a flag to true and then sets it to false after 100ms.
     */
    refreshUseridFilter() {
      // Set flag to true
      this.filterUseridRefresh = true;

      // Set flag to false at the next tick
      setTimeout(() => (this.filterUseridRefresh = false));
    },

    /**
     * Sets the filter for a given field and value.
     * @param {string} field - Field name (e.g. game, level, verbosity).
     * @param {string} value - Value of the filter (e.g. "dust-prod-v0.2.0", "memoire", "info").
     */
    setFilter(field, value) {
      // Set filter
      if (value == field + "s" || value == "") this.filter[field] = "";
      else this.filter[field] = value;

      // Apply filter
      // if (field == "mapid") this.getNextPage(true);
      // else this.getNextPage(true);
      this.getNextPage(true, field);
    },

    /**
     * getColor - Returns the CSS color class based on the verbosity level.
     * @param {string} verbosity - Verbosity level (e.g. "info", "warn", "error").
     * @returns {string} CSS color class (e.g. "text-info", "text-warning", "text-danger").
     */
    getColor(verbosity) {
      switch (verbosity) {
        case "Default":
          return "text-muted";
        case "Log":
          return "text-info";
        case "Warning":
          return "text-warning";
        case "Error":
          return "text-danger";
        default:
          return "";
      }
    },

    /**
     * resize - Resizes the textarea to fit its content. It also sends a request
     * to get the next page of logs if the user presses Ctrl+Enter.
     *
     * @param {KeyboardEvent} event - Keyboard event.
     */
    resize(event = {}) {
      // Get next page if user presses Ctrl+Enter
      if (event.ctrlKey && event.key === "Enter") {
        // Send request to get the next page of logs
        this.getNextPage(true);
      }

      // Resize the textarea to fit its content
      const { textarea } = this.$refs;
      textarea.style.height = textarea.scrollHeight + "px";
    },
  },
};
</script>

<style scoped>
div.timestamp {
  font-size: small;
}
div.message {
  word-wrap: break-word;
  max-width: 100%; /* adjust the width as needed */
}

.input-group > button.clear {
  padding-top: 4px;
  z-index: 100;
  border: var(--bs-border-width) solid var(--bs-border-color);
}

.input-group > button.clear span {
  opacity: 0.5;
}
.input-group > button.clear:hover span {
  opacity: 1;
}

.input-group > button.calendar {
  padding-top: 5px !important;
}

.verbosity-label {
  padding-top: 5px !important;
}
.total {
  padding-top: 5px;
}

:has(.show.mapid) .list,
:has(.show.mapid) .next-page,
:has(.show.mapid) .verbosity-filter,
:has(.show.mapid) .total,
:has(.show.mapid) .view-filter,
:has(.show.mapid) .userid-filter {
  display: none !important;
}

:has(.show.userid) .list,
:has(.show.userid) .next-page,
:has(.show.userid) .verbosity-filter,
:has(.show.userid) .total,
:has(.show.userid) .view-filter,
:has(.show.userid) .mapid-filter {
  display: none !important;
}

.view-filter {
  padding-top: 10px;
}

.view-filter span {
  padding-left: 5px;
  padding-top: 4px;
  padding-right: 6px;
}

.input-group > button.operation {
  font-size: small;
  opacity: 0.5;
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 0;
  z-index: 100;
}
.input-group > button.operation[operation="or"] {
  margin-left: -84px !important;
  padding-right: 8px;
}
.input-group > button.operation[operation="and"] {
  margin-left: -94px !important;
  padding-right: 8px;
}
.input-group > button.operation:hover {
  opacity: 1;
}
.input-group > button.operation.hide {
  opacity: 0;
  cursor: text;
}

.input-group > textarea {
  margin-right: 56px;
  padding-right: 37px;
}

.time-label {
  width: 94px;
  white-space: nowrap;
}

.dropdown-toggle {
  margin-top: -6px;
}

.list-item {
  padding: 8px;
}
.list-item hr {
  margin: 0;
  margin-bottom: 18px;
}
.list-item.simple:nth-of-type(odd) {
  background-color: var(--bs-secondary-bg);
}

.download {
  opacity: 0.5;
}
.download:hover {
  opacity: 1;
}
</style>
